import _ from 'lodash';

export default class messageCtrl {
  constructor(Message, urlParser, MessageParser, NotificationsService, blConfirmService, User) {
    this.Message = Message;
    this.urlParser = urlParser;
    this.MessageParser = MessageParser;
    this.NotificationsService = NotificationsService;
    this.blConfirmService = blConfirmService;
    this.clientId = User.getClientId();
    this.confirmDeleteMessage = this.confirmDeleteMessage.bind(this);
    this.closeEditMessage = this.closeEditMessage.bind(this);
    this.hasReadReceipt = this.hasReadReceipt.bind(this);
    this.openEditMessage = this.openEditMessage.bind(this);
    this.putMessage = this.putMessage.bind(this);
    this.destroyMessage = this.destroyMessage.bind(this);
    this.getMessageDisplayPayloads = this.getMessageDisplayPayloads.bind(this);
    this.resendMessage = this.resendMessage.bind(this);
    this.setEditMessageInput = this.setEditMessageInput.bind(this);
    this.showCopyErrorNotification = this.showCopyErrorNotification.bind(this);
    this.showCopySuccessNotification = this.showCopySuccessNotification.bind(this);
  }

  $onInit() {
    this.message = new this.Message(this.messageId);
    this.setDefaults();
  }

  setDefaults() {
    this.showEdit = false;
    this.showMobileIcon = this.isMessageMobile();
  }

  isMessageMobile() {
    const messageOrigin = this.message.context.eventSource.component;
    return this.showMessageSource && messageOrigin === 'messaging.mobile';
  }

  isBookkeeper() {
    return !!this.bookkeeperId && !!this.message.$isAuthor(this.bookkeeperId);
  }

  hasReadReceipt() {
    return !!this.bookkeeperId && !!this.message.hasReadReceipt();
  }

  isAssetType(name) {
    return _.find(this.message.assets, {
      assetType: 'payload',
      payloadName: name,
    });
  }

  getRawMessagePayload() {
    const asset = _.find(this.message.assets, {
      assetType: 'payload',
      payloadName: 'message',
    });
    return asset?.payload || '';
  }

  getMessageDisplayPayloads() {
    return (this.message.assets || [])
      .filter(asset => asset.assetType === 'payload' && asset.payloadName === 'message')
      .map(asset => asset.payload);
  }

  getMessageAvatarEmail() {
    if (this.message?.$isAuthorSystem?.()) {
      return 'help@bench.co';
    }

    return this.message?.$author?.()?.email || '';
  }

  sentWithSms() {
    return this.message.sentWithSms();
  }

  openEditMessage() {
    this.editMessageInput = this.getRawMessagePayload();
    this.showEdit = true;
  }

  confirmDeleteMessage() {
    return this.blConfirmService
      .openConfirm(
        'Are you sure you want to delete this message?',
        '<span class="bl-icon-trash ngdialog-icon"></span>',
      )
      .then(() => this.deleteMessage());
  }

  closeEditMessage() {
    this.showEdit = false;
  }

  setEditMessageInput(value) {
    this.editMessageInput = value;
  }

  updateMessagePayload(text) {
    const assets = (this.message.assets || []).map(asset => {
      if (asset.assetType === 'payload' && asset.payloadName === 'message') {
        return {
          ...asset,
          payload: text,
        };
      }

      return asset;
    });

    this.message.$set({
      assets,
      payload: {
        ...(this.message.payload || {}),
        message: text,
      },
    });
  }

  putMessage() {
    const parsers = this.bookkeeperId ? [this.urlParser] : [];

    const { message } = this.MessageParser.parse(this.editMessageInput, parsers);

    if (!message) {
      return;
    }

    this.NotificationsService.loader({
      resolve: this.message.$put(message),
      loadingText: 'Saving...',
      successText: 'Updated.',
      failureText: 'Failed to save message.',
    })
      .then(() => {
        this.updateMessagePayload(message);
        this.closeEditMessage();
      })
      .catch(() => undefined);
  }

  deleteMessage() {
    this.message.$delete();
  }

  resendMessage() {
    this.message.$post();
  }

  destroyMessage() {
    this.message.$destroy();
  }

  showCopySuccessNotification() {
    this.NotificationsService.add('Message copied to clipboard.', { length: 3, type: 'success' });
  }

  showCopyErrorNotification() {
    this.NotificationsService.add('Failed to copy message.', { length: 3, type: 'error' });
  }
}
